import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-blood-pressure',
    templateUrl: './blood-pressure.component.svg',
    styleUrls: ['./blood-pressure.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloodPressureComponent {}
